import React, { useState, ChangeEvent, FormEvent } from "react";
import { Button, Input } from "@material-tailwind/react";
import { useNavigate } from "react-router-dom";
const jsonp = require("jsonp");

function Form(): JSX.Element {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [nameError, setNameError] = useState("");
  const [containsError, setContainsError] = useState(false);
  const [containsNameError, setContainsNameError] = useState(false);

  
  const handleSubmit = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();

    const url =
      "https://ciphers.us9.list-manage.com/subscribe/post-json?u=9a97bea7b4b59eb51d3e56dc9&id=6276a71623&f_id=003006e1f0";
    jsonp(
      `${url}&EMAIL=${email}&NAME=${name}&TAGS=12561103`,
      { param: "c", timeout: 5000 },
      (err: any, data: any) => {
        if (err) {
          setContainsError(true);
          setEmailError(
            "Error: Something went wrong. Please check your browser policy or ad blockers."
          );
        } else if (data.result === "success") {
          setContainsError(false);
          navigate("/joined", { state: { name, email } });
          //console.log(e);
        } else {
          setEmailError("Something went wrong mail us instead!");
          setContainsError(true);
          console.log(e);
        }
      }
    );
  };

  const validateEmail = (email: string): boolean => {

      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,4})?$/;

      return emailPattern.test(email);
  };

  const handleNameChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const newName = e.target.value;
    setName(newName);

    if (!newName) {
      setContainsNameError(true);
      setNameError("Please enter your name.");
    } else {
      setContainsNameError(false);
      setNameError("");
    }
  };

 
  const handleEmailChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const newEmail = e.target.value;
    setEmail(newEmail);

    if (!validateEmail(newEmail)) {
      setContainsError(true);
      setEmailError("Please enter a valid email");
    } else {
      setContainsError(false);
      setEmailError("");
    }
  };

  return (
    <div className="bg-primary rounded-lg mt-5 2xl:w-[400px]">
      <div className="">
        <form onSubmit={handleSubmit} id="form">
          <div className="p-4">
            <div className="text-white text-3xl font-bold pb-4 pt-4">
              <h2>Stay up-to-date</h2>
            </div>
            <div className="text-white text-1xl pb-8">
              <p>
                Please provide your contact information below, and we will
                promptly notify you upon the release of Ciphers.me
              </p>
            </div>
            <div className="text-1xl pb-4">
              <p className="text-white pb-2 text-[16px] font-bold">Name</p>
              <Input
                name="name"
                id="name"
                className={`relative h-12 p-[15px] w-full rounded-sm outline-0 ${
                  containsNameError
                    ? "border-tertiary border-solid border-[2px]"
                    : "border-successAlpha-900 border-solid border-[2px]"
                }`}
                crossOrigin={undefined}
                value={name}
                onChange={handleNameChange}
              />
              {nameError && (
                <p className="text-tertiary text-sm">{nameError}</p>
              )}
            </div>
            <div className="text-black text-1xl pb-4">
              <p className="text-white pb-2 text-[16px] font-bold">Email</p>
              <Input
                name="email"
                id="email"
                className={`relative h-12 p-[15px] w-full rounded-sm outline-0 ${
                  containsError
                    ? "border-tertiary border-solid border-[2px]"
                    : "border-success border-solid border-[2px]"
                } `}
                crossOrigin={undefined}
                value={email}
                onChange={handleEmailChange}
              />
              {emailError && (
                <p className="text-tertiary text-sm">{emailError}</p>
              )}
            </div>
            <div className="hidden">
              <Input
                id="tags"
                name="tags"
                crossOrigin={undefined}
                defaultValue="12561103"
              />
            </div>
            <div className="pt-4">
              <Button
                type="submit"
                className={`bg-tertiary w-full font-extrabold text-base ${
                  containsError || !name ? "disabled" : ""
                }`}
                disabled={containsError || !name}
              >
                Notify me
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Form;
